module.exports = __webpack_public_path__ + "static/media/resultLogo.e3f89332.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/resultLogo.png
// module id = 299
// module chunks = 0